import { createSelector } from 'reselect';

export const selectAreIndicatorsLoading = createSelector(
  [
    (state) => state.treasuryPage?.status,
    (state) => state.turnoverPage?.status,
    (state) => state.HRPage?.status,
  ],
  (treasuryStatus, turnoverStatus, HRStatus) =>
    [treasuryStatus, turnoverStatus, HRStatus].some(
      (status) => status === 'LOADING'
    )
);
